import { getWssQueryParam } from '@rsos/utils/metaTags';
import HermesClientBase from './HermesClientBase';

/**
 * Hermes real-time data messaging service client for the `/v1/stream`
 * endpoint. The connection and reconnection lifecycle lives in
 * HermesClientBase, shared with the `/hermes/connect` client.
 */
class StreamWS extends HermesClientBase {
  constructor(...args) {
    super(...args);
    this._client = 'streamWS';
  }

  /** @private */
  get _connectPath() {
    return '/v1/stream';
  }

  /** @private */
  get _extraQueryParams() {
    return getWssQueryParam();
  }
}

export default StreamWS;
